<template>
  <div>
    <el-button style="margin-top:2.5px;" size="mini" type="secondary" @click="clickEventPredictAnalysisButton">
      장애 예측 분석
    </el-button>
    <w-sliding-popup ref="eventPredictAnalysisPopup" class="analysis-pop-loading" type="full" title="장애 예측 분석" :default-content="false" @close="closePopup">
      <div slot="content" class="body-content-no-scroll" style="height:100%;" v-loading="loadingFlag" :element-loading-text="loadingText">
        <el-tabs class="tab-button" v-model="activeTab">
          <el-tab-pane label="예측 자원 설정" name="WPredictAnalysisSetting">
            <w-predict-analysis-setting ref="WPredictAnalysisSetting" :active-tab="activeTab"></w-predict-analysis-setting>
          </el-tab-pane>
          <el-tab-pane label="분석 결과" name="WAnalysisResult">
            <w-analysis-result ref="WAnalysisResult"  :active-tab="activeTab" @excel-loading="excelLoading"></w-analysis-result>
          </el-tab-pane>
        </el-tabs>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import WPredictAnalysisSetting from './PredictAnalysisSetting';
import WAnalysisResult from './AnalysisResult';

export default {
  name: 'WEventPredictAnalysisButton',
  components: {
    WPredictAnalysisSetting,
    WAnalysisResult,
  },
  props: {
  },
  watch: {
    activeTab() {
      this.activeTabLoad();
    },
  },
  data() {
    return {
      activeTab: 'WPredictAnalysisSetting',
      loadingFlag: false,
      loadingText: null,
    };
  },
  methods: {
    /**
     * 장애 예측 분석 팝업을 연다.
     * @author Song
     */
    clickEventPredictAnalysisButton() {
      this.$refs.eventPredictAnalysisPopup.open();
      this.$nextTick(() => {
        this.activeTabLoad();
      });
    },
    closePopup() {
      // init
      // 테이블 필터링들 초기화
    },
    /**
     * 장애 예측 분석 - 탭에 맞는 loadData를 실행
     * @author Song
     */
    activeTabLoad() {
      // loadData
      this.$nextTick(() => {
        const activeTab = this.activeTab;
        this.$refs[activeTab].loadData();
      });
    },
    excelLoading(flag) {
      this.loadingText = '엑셀 파일을 생성중입니다. 잠시만 기다려 주세요.';
      this.loadingFlag = flag;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/EventPredictAnalysisButton.vue